import { DomainApi, FilespaceApi, BillingApi, DefaultApi, NosecurityApi } from 'fs-api-client';
import { authenticationService } from '../services/authentication';

const baseUrl = location.protocol + '//' + location.host + '/api/v1';

async function attachToken(api: any): Promise<any> {
    api.accessToken = await authenticationService.getIdToken();
    return api;
}

export async function createDomainApi(): Promise<DomainApi> {
    return await attachToken(new DomainApi(baseUrl));
}

export async function createFilespaceApi(): Promise<FilespaceApi> {
    return await attachToken(new FilespaceApi(baseUrl));
}

export async function createBillingApi(): Promise<BillingApi> {
    return await attachToken(new BillingApi(baseUrl));
}

export async function createDefaultApi(): Promise<DefaultApi> {
    return await attachToken(new DefaultApi(baseUrl));
}

export function createNoSecurityApi(): NosecurityApi {
    return new NosecurityApi(baseUrl);
}



// WEBPACK FOOTER //
// ./src/webportal/utils/createApi.ts